import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';
import styled from 'styled-components';

const BaseIndustryBadges = ({ data, className }) => (
  <div className={className}>
    <a href='https://www.aisc.org/' target='window'>
      <Img
        fluid={data.aisc.childImageSharp.fluid}
        alt='AISC - American Institute of Steel Construction'
      />
    </a>
    <a href='http://www.ironworkers.org/' target='window'>
      <Img
        fluid={data.ia4soiw.childImageSharp.fluid}
        alt='IAFSOOI - International Associatation for Structural and Ornamental Ironworkers'
      />
    </a>
    <a href='https://www.agc.org/' target='window'>
      <Img
        fluid={data.agc.childImageSharp.fluid}
        alt='AGC - The Associated General Contractors of America'
      />
    </a>
    <a href='https://www.impact-net.org/' target='window'>
      <Img
        fluid={data.impact.childImageSharp.fluid}
        alt='I.M.P.A.C.T. - Ironworker Management Progressive Action Cooperative Trust'
      />
    </a>
    <a href='https://ccs-safety.org/' target='window'>
      <Img
        fluid={data.ccs.childImageSharp.fluid}
        alt='CCS - Coalition of Construction Safety'
      />
    </a>
    <a href='https://www.aws.org/' target='window'>
      <Img
        fluid={data.aws.childImageSharp.fluid}
        alt='AWS - American Welding Society'
      />
    </a>
  </div>
);

const IndustryBadges = styled(BaseIndustryBadges)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 65px;
  margin-left: 10px;
  margin-right: 10px;
  a {
    width: 7.986%;
  }
`;

// Fetch the industry badge Images

export default props => (
  <StaticQuery
    query={graphql`
      query {
        aisc: file(relativePath: { eq: "aisc-logo.png" }) {
          childImageSharp {
            fluid(maxWidth: 80) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        ia4soiw: file(relativePath: { eq: "ia4soiw-logo.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 80) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        agc: file(relativePath: { eq: "agc-logo.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 80) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        impact: file(relativePath: { eq: "impact.png" }) {
          childImageSharp {
            fluid(maxWidth: 80) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        ccs: file(relativePath: { eq: "ccs-logo.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 80) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        aws: file(relativePath: { eq: "aws-logo.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 80) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={data => <IndustryBadges data={data} {...props} />}
  />
);
